import { custom, success } from "./utilities";
import { activityConstants, globalConstants } from "../../constants";
import { activityService } from "../../services/activity.services";
import { ToastifyService } from "../../services/toastify.services";
import { candidateActions } from "./candidate.actions";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION
};

export const getAllActivity = (gridState, candidateId) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .getAll(gridState, candidateId)
      .then((response) => {
        dispatch(success(response, activityConstants.GET_ACTIVITY));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getActivityById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .getById(id)
      .then((response) => {
        dispatch(success(response, activityConstants.GET_ACTIVITY_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getInvoiceByActivityId = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .getInvoiceByActivityId(id)
      .then((response) => {
        dispatch(success(response, activityConstants.GET_INVOICE_BY_ACTIVITY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteActivityById = (id, candidateId) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllActivity(gridData, candidateId));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createActivity = (data, candidateId, onHide) => {
  return (dispatch) => {
    
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .create(data)
      .then((response) => {
        dispatch(getAllActivity(gridData, candidateId));
        dispatch(candidateActions.getAllCandidate(gridData, data.RecallId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateActivity = (data, candidateId, onHide) => {
  return (dispatch) => {
    console.log("RecallId", data);
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .update(data)
      .then((response) => {
        dispatch(getAllActivity(gridData, candidateId));
        dispatch(candidateActions.getAllCandidate(gridData, data.RecallId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllActivityList = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .getAllActivityList()
      .then((response) => {
        dispatch(success(response.items, activityConstants.GET_ACTIVITY_LIST));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const generateInvoice = (data, id = 0, setViewInvoice) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .generateInvoice(data, id)
      .then((response) => {
        dispatch(getAllInvoices(gridData));
        setViewInvoice(true);
        dispatch(success(response, activityConstants.GENERATE_INVOICE_BY_ACTIVITY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllInvoices = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .getAllInvoices(gridState)
      .then((response) => {
        dispatch(success(response, activityConstants.GET_ALL_INVOICES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const acceptedActivity = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    activityService
      .acceptedActivity()
      .then((response) => {
        dispatch(success(response.items, activityConstants.GET_ACCEPTED_ACTIVITIES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const activityActions = {
  getAllActivity,
  getActivityById,
  deleteActivityById,
  createActivity,
  updateActivity,
  getAllActivityList,
  getInvoiceByActivityId,
  generateInvoice,
  getAllInvoices,
  acceptedActivity
};
